/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__xiangkan */
function tpl__xiangkan() {
    return '<iframe scrolling="no" height=0 name="xiangkan-detail__iframe" class="xiangkan-detail__iframe"></iframe>';
}

exports.tpl__xiangkan = tpl__xiangkan;
